var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "35px",
    viewBox: "0 0 38 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0B66A852-9D13-4D23-8114-E0B90C0A4163") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.070588 0 0 0 0 0.415686 0 0 0 0 0.541176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_11",
    transform: "translate(-280.000000, -310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circular-line-with-word-age-in-the-center",
    transform: "translate(260.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4229816,13.0110784 L28.851092,21.9838889 L31.9304908,21.9838889 C29.9920245,27.9219935 24.3227975,32.2382026 17.6340982,32.2382026 C9.3512638,32.2382026 2.61174233,25.6252614 2.61174233,17.4974837 C2.61174233,9.36993464 9.3512638,2.75676471 17.6340982,2.75676471 C24.0162331,2.75676471 29.4686503,6.68911765 31.6397791,12.2101961 L33.1411288,9.26333333 C30.1540491,3.86578431 24.3241963,0.193300654 17.6352638,0.193300654 C7.91146012,0.193300654 0,7.95575163 0,17.4974837 C0,27.0385294 7.91146012,34.8018954 17.6350307,34.8018954 C25.7768221,34.8018954 32.6324417,29.3553922 34.6527362,21.9841176 L37.9948712,21.9841176 L33.4229816,13.0110784 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27280982,20.9501307 L9.92429448,20.9501307 L10.4255215,19.1774837 L12.4409202,19.1774837 L12.9845767,20.9501307 L14.696908,20.9501307 L12.5143558,14.0434641 L10.4255215,14.0434641 L8.27280982,20.9501307 Z M11.0722209,16.5437908 C11.1871534,16.1436928 11.2915951,15.6209804 11.3962699,15.211732 L11.4167853,15.211732 C11.5214601,15.6209804 11.6471166,16.135 11.772773,16.5437908 L12.2115215,18.010817 L10.6553865,18.010817 L11.0722209,16.5437908 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0552515,15.2632026 C19.8271411,15.2632026 20.3073865,15.3965686 20.6939141,15.5592157 L21.0286871,14.3088235 C20.6838896,14.1452614 19.9838037,13.9702614 19.0757669,13.9702614 C16.7675583,13.9702614 15.0659509,15.2812745 15.0535951,17.577549 C15.0438037,18.5918627 15.3986258,19.4927124 16.0467239,20.0888562 C16.6943558,20.7037582 17.6233742,21.0212745 18.9088466,21.0212745 C19.8366994,21.0212745 20.7680491,20.7959477 21.2576196,20.6321569 L21.2576196,16.9942157 L18.6370184,16.9942157 L18.6370184,18.2137255 L19.7245644,18.2137255 L19.7245644,19.6578758 C19.5982086,19.7205556 19.3053988,19.7605882 18.9400859,19.7605882 C17.6336319,19.7605882 16.7260613,18.9194444 16.7260613,17.4949673 C16.7260613,16.0002614 17.7275828,15.2632026 19.0552515,15.2632026 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "26.8506135 15.3251961 26.8506135 14.0446078 22.5060245 14.0446078 22.5060245 20.9501307 26.9972515 20.9501307 26.9972515 19.6706863 24.1041227 19.6706863 24.1041227 18.0309477 26.6948834 18.0309477 26.6948834 16.7590523 24.1041227 16.7590523 24.1041227 15.3251961"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeIcon);
export default __webpack_public_path__ + "static/media/AgeIcon.e9d3cd87f34b0ccf6b334564eee4e0ec.svg";
export { ForwardRef as ReactComponent };